// Module
var code = "<!-- ko with: Model --> <h4>Email:</h4> <input data-bind=\"value: MailAddress\" type=\"text\" class=\"form-control\"> <span data-bind=\"validationMessage: MailAddress\" class=\"help-block\"></span> <br> <!-- /ko --> <input data-bind=\"click: $data.Save.bind($data)\" class=\"btn btn-info\" type=\"button\" value=\"Add mail\">";
// Exports
export default code;